<template>
  <div>
    <h1>Next Steps for BreakTimer</h1>
    <p>
      If you'd like to hack with us, here are some improvements we could make:
      Refactor code <br />
      Add unit tests <br />
      Customize player + add skin <br />
      Add push notifications <br />
      Choose multiple mp3’s <br />
      Package into chrome extension
    </p>

    <div>
      Since everyone who knows this knows us, hit us up at the office and let us
      know how we can make this a better product for you !
    </div>
  </div>
</template>
<script>
export default {
  name: 'NextSteps'
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/NextSteps.vue